import { render, staticRenderFns } from "./data-panel.vue?vue&type=template&id=1878f4f0&scoped=true&"
import script from "./data-panel.vue?vue&type=script&lang=js&"
export * from "./data-panel.vue?vue&type=script&lang=js&"
import style0 from "./data-panel.vue?vue&type=style&index=0&id=1878f4f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878f4f0",
  null
  
)

export default component.exports